import { inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  
  private showLoaderSubject = new Subject<String>();
  showLoaderEvent$ = this.showLoaderSubject.asObservable();
  
  private hideLoaderSubject = new Subject<void>();
  hideLoaderEvent$ = this.hideLoaderSubject.asObservable();

  constructor() { }


  showLoader(){
    this.showLoaderSubject.next("");
  }

  hideLoader(){
    this.hideLoaderSubject.next();
  }
}
